export default __webpack_public_path__ + "static/media/saleshandy-header-logo.9ad73dd4.svg";